<template lang="pug">
div.animated.fadeIn
  // conclusion by duration
  b-card
    div.row
      div.col-sm-4
      div.col-sm-8
        div.dateRangePickerContainer
          i(class="fa fa-calendar")
          date-range-picker.ml-2.dateRangePicker(ref="ref" :options="options")
          i(class="fa fa-caret-down")
    br
    div(id='graphContainer' style='height: 800px')
</template>

<script>
// import { db } from '@/firebase'
import echarts from 'echarts'
import $ from 'jquery'
import sampleData from './sample-data.json'
var moment = require('moment')
// const anaRef = db.ref('analytics')

export default {
  name: 'dashboard',
  data() {
    return {
      initialise: true,
      userAccessLevel: this.$store.state.profile.accessLevel,
      // for date range picker
      options: {
        startDate: moment('20190826').subtract(29, 'days'),
        endDate: moment('20190826'),
        locale: {
          format: 'DD/MM/YYYY',
        },
        ranges: {
          'Last 7 Days': [moment('20190826').subtract(6, 'days'), moment('20190826')],
          'Last 30 Days': [moment('20190826').subtract(29, 'days'), moment('20190826')],
          'This Month': [moment('20190826').startOf('month'), moment('20190826').endOf('month')],
          'Last Month': [moment('20190826').subtract(1, 'month').startOf('month'), moment('20190826').subtract(1, 'month').endOf('month')],
        },
      },
      yAxisLabels: [],
      sliderEndPoint: '',
      sliderStartPoint: '',
      option: null,
      visualMin: -100,
      visualMax: 100,
      visualMinBound: -40,
      visualMaxBound: 40,
      fullData: null,
    }
  },
  mounted: function() {
    const el = $(this.$refs.ref.$el)
    el.on('apply.daterangepicker', (event, picker) => {
      let data = JSON.parse(JSON.stringify(this.fullData))
      let sliderStartTime = new Date(picker.startDate.format('L'))
      let sliderEndTime = new Date(picker.endDate.format('L'))
      Object.entries(data).forEach(function([key, val]) {
        const day = key.substring(6)
        const month = key.substring(4, 6)
        const year = key.substring(0, 4)
        let keyTime = new Date(`${month}-${day}-${year}`)
        if (keyTime < sliderStartTime) {
          delete data[key]
        } else if (keyTime > sliderEndTime) {
          delete data[key]
        }
      })
      this.loadData(data)
    })
    this.getGraph()
  },
  methods: {
    getGraph() {
      this.fullData = sampleData.daily
      let data = JSON.parse(JSON.stringify(sampleData.daily))
      let sliderEndTime = new Date('26-08-2019')
      let sliderStartTime = new Date(sliderEndTime - 30 * 24 * 60 * 60 * 1000)
      Object.entries(data).forEach(function([key, val]) {
        const day = key.substring(6)
        const month = key.substring(4, 6)
        const year = key.substring(0, 4)
        let keyTime = new Date(`${month}-${day}-${year}`)
        if (keyTime < sliderStartTime) {
          delete data[key]
        } else if (keyTime > sliderEndTime) {
          delete data[key]
        }
      })
      this.loadData(data)
    },
    loadData(data) {
      var dom = document.getElementById('graphContainer')
      var myChart = echarts.init(dom)

      const treemapData = [{
        value: 0,
        name: 'SmallTalks',
        id: 'SmallTalks-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Default',
        id: 'Default-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'General Info',
        id: 'General-Info-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Cust Service',
        id: 'Cust-Service-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Getting There',
        id: 'Getting-There-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Room',
        id: 'Room-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Stock Price',
        id: 'Stock-Price-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Booking',
        id: 'Booking-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Membership',
        id: 'Membership-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'CDN',
        id: 'CDN-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Broker',
        id: 'Broker-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Sector',
        id: 'Sector-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Dining',
        id: 'Dining-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Latest News Intent',
        id: 'Latest-News-branch',
        discretion: null,
        children: [],
      }, {
        value: 0,
        name: 'Default Fallback Intent',
        id: 'Fallback-branch',
        discretion: null,
        children: [],
      }]

      Object.entries(data).forEach(function([key, val]) {
        const dailyDatas = Object.values(val)
        Object.entries(dailyDatas[0]).forEach(([intentName, intentData]) => {
          let index = 0
          if (intentName.includes('ST0') || intentName.includes('ST7')) {
            index = 0
          } else if (intentName.includes('i00')) {
            index = 1
          } else if (intentName.includes('i10')) {
            index = 2
          } else if (intentName.includes('i11')) {
            index = 3
          } else if (intentName.includes('i12')) {
            index = 4
          } else if (intentName.includes('i20')) {
            index = 5
          } else if (intentName.includes('i21')) {
            index = 6
          } else if (intentName.includes('i22')) {
            index = 7
          } else if (intentName.includes('i23')) {
            index = 8
          } else if (intentName.includes('i31')) {
            index = 9
          } else if (intentName.includes('i32')) {
            index = 10
          } else if (intentName.includes('i33')) {
            index = 11
          } else if (intentName.includes('i34')) {
            index = 12
          } else if (intentName.includes('Default Welcome')) {
            index = 13
          } else if (intentName.includes('Default Fallback')) {
            index = 14
          } else if (intentName.includes('tt ') || intentName.includes('TT ') || intentName.includes('Room-FreeRoom') || intentName.includes('Get Started - ')) {
            index = 15
          }
          if (index != 15) {
            treemapData[index].value += intentData.interactions || 0
            let foundMatch = false
            treemapData[index].children.forEach(function(element, key) {
              if (element.name == intentName) {
                treemapData[index].children[key].value += intentData.interactions || 0
                foundMatch = true
              }
            })

            if (foundMatch == false) {
              treemapData[index].children.push({
                value: intentData.interactions || 0,
                name: intentName,
                id: intentName,
                discretion: 'mandatory',
              })
            }
          }
        })
      })
      this.convertData(treemapData)
      this.treemapData = treemapData
      this.setOption(this.treemapData)
      if (this.option && typeof this.option === 'object') {
        myChart.setOption(this.option, true)
      }
    },
    convertData(originList) {
      var min = Infinity
      var max = -Infinity

      for (let i = 0; i < originList.length; i++) {
        let node = originList[i]
        if (node) {
          let value = node.value
          value != null && value < min && (min = value)
          value != null && value > max && (max = value)
        }
      }

      for (let i = 0; i < originList.length; i++) {
        let node = originList[i]
        if (node) {
          if (node.children) {
            this.convertData(node.children)
          }
        }
      }
    },
    setOption(treemapData) {
      this.option = {
        backgroundColor: '#fff',
        animation: false,
        title: {
          top: 5,
          left: 5,
          text: 'Intents Treemap',
        },
        toolbox: {
          orient: 'vertical',
          top: 5,
          right: 20,
          showTitle: false,
          feature: {
            dataZoom: {
              yAxisIndex: false,
              show: false,
            },
            restore: {},
            saveAsImage: {},
          },
        },
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
            animation: false,
            shadowStyle: {color: 'rgba(50, 181, 217, 0.1)'},
          },
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          transitionDuration: 0.1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
            color: '#000',
          },
          formatter: function (info) {
            var value = info.value
            var amount = value
            return [
              '<div class="tooltip-title">' + echarts.format.encodeHTML(info.name) + ' (' + amount + ')</div>',
              '',
            ].join('')
          },
        },
        series: [{
          name: 'ALL',
          top: 80,
          type: 'treemap',
          selectedMode: 'single',
          upperLabel: {
            normal: {
              show: true,
              padding: 5,
              fontSize: 12,
              fontWeight: 'bold',
              height: 30,
            },
          },
          label: {
            position: 'insideTopLeft',
            show: true,
            formatter: function (params) {
              var arr = [
                '{name|' + params.name + '} {label|Name}',
                '{hr|}',
                '{intentNum|' + echarts.format.addCommas(params.value) + '} {label|interactions}',
              ]
              return arr.join('\n')
            },
            rich: {
              intentNum: {
                fontSize: 20,
                color: '#32b5d9',
              },
              label: {
                fontSize: 9,
                backgroundColor: 'rgba(0,0,0,0.3)',
                color: '#fff',
                borderRadius: 2,
                padding: [2, 2],
                lineHeight: 25,
                align: 'left',
              },
              name: {
                fontSize: 10,
                fontWeight: 'bold',
                color: '#50666D',
              },
              hr: {
                width: '100%',
                borderColor: '#99e0da',
                borderWidth: 0.5,
                height: 0,
                lineHeight: 10,
              },
            },
          },
          itemStyle: {
            normal: {
              borderColor: '#32b5d9',
            },
          },
          visualMin: this.visualMin,
          visualMax: this.visualMax,
          visualDimension: 0,
          levels: [
            {
              itemStyle: {
                normal: {
                  borderWidth: 3,
                  borderColor: '#50666D',
                  gapWidth: 3,
                },
              },
            },
            {
              color: [
                '#fff9cf',
                '#d5e6ff',
                '#b4f6ff',
                '#beffed',
                '#effcd1',
                '#d0edf7',
                '#ffe0e2',
                '#eddfed',
                '#f4f7d0',
                '#f2ecc7',
              ],
              itemStyle: {
                normal: {
                  gapWidth: 0,
                },
              },
            },
          ],
          data: treemapData,
        }],
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Analytics/IntentsTreemap.vue?8aa055b4